export interface EstimatedReadTimeConfig {
  readonly secondsPerProfile: number;
}

export const DEFAULT_ESTIMATED_READ_TIME_CONFIG: EstimatedReadTimeConfig = {
  secondsPerProfile: 50,
};

export class EstimatedReadTimeService {
  static calculateMinutes(
    profileCount: number,
    config: EstimatedReadTimeConfig = DEFAULT_ESTIMATED_READ_TIME_CONFIG,
  ): number {
    const totalSeconds = profileCount * config.secondsPerProfile;
    return Math.ceil(totalSeconds / 60);
  }

  static format(
    profileCount: number,
    config: EstimatedReadTimeConfig = DEFAULT_ESTIMATED_READ_TIME_CONFIG,
  ): string {
    const totalMinutes = EstimatedReadTimeService.calculateMinutes(
      profileCount,
      config,
    );

    if (totalMinutes < 60) {
      return `${totalMinutes}m`;
    }

    const hours = totalMinutes / 60;

    const roundedHours = Math.round(hours * 2) / 2;

    return `${roundedHours}h`;
  }
}
